import { Injectable, inject } from '@angular/core';

import { NativeAppService, NativeEvent, OnAppInit, ProductHomepagesConfig } from '@frontend/vanilla/core';
import { rxEffects } from '@rx-angular/state/effects';

import { McPageClientConfig } from '../../client-config';

@Injectable({ providedIn: 'root' })
export class NativeBoostrapService implements OnAppInit {
    private readonly mcPage = inject(McPageClientConfig);
    private readonly nativeApp = inject(NativeAppService);
    private readonly productHomepages = inject(ProductHomepagesConfig);

    private readonly rxEffects = rxEffects();

    previousUrl = this.mcPage.prefix;

    onAppInit() {
        //This is getting used my native
        this.handleNativeEvents();
    }

    private handleNativeEvents() {
        this.rxEffects.register(this.nativeApp.eventsFromNative, (e: NativeEvent) => {
            const eventName = e?.eventName?.toUpperCase();
            const eventParams = e?.parameters;
            if (eventName === 'CASINO_SESSION_KEY' && eventParams?.sessionKey) {
                const clientUrl: string =
                    this.productHomepages.casino +
                    '/casino?invokerProduct=' +
                    this.nativeApp.product +
                    '&_nativeApp=' +
                    this.nativeApp.applicationName +
                    '&_sso=' +
                    eventParams.sessionKey;
                window.location.href = clientUrl;
            }
        });
    }
}
